import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface DateContainerProps {
  children: React.ReactNode;
}

const ContainerComponent: React.FC<DateContainerProps> = ({ children }) => {
  return <div className="peptalk-date-wrapper">{children}</div>;
};

export const Container: React.FC<DateContainerProps> = (
  props: DateContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'DateContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
